<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .filters__container
        .dates__container
          .date__container
            el-date-picker(
              v-model="date"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        el-button(type="primary" @click="startLoadStats()" :disabled="isLoading") Запросить
      .stats__container
        .stats__chart
          BarChart(:chartData="ordersStats" :listenEvents="true" @showUserOrdersIds="this.showUserOrdersIds" chartId="orders-stats")
        .stats__chart
          BarChart(:chartData="messagesStats" chartId="messages-stats")
        .stats__chart
          BarChart(:chartData="otherStats" chartId="other-stats")
    el-dialog(:visible.sync="ordersChartDetails.show" :before-close="resetShowOrdersChartDetails" :title="showOrdersChartDetailsTitle" width="30%")
      .orders-ids__list
        .order__id(v-for="(id, index) in ordersChartDetails.ids" :key="`orders-chart-order-id-${id}-${index}`") {{ id }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_ACTIONS_STATS } from "../../store/const/settings";
import BarChart from './BarChart'

export default {
  name: 'ActionsStats',
  components: { BarChart },
  data() {
    return {
      date: '',
      dateOptions: {
        shortcuts: [{
          text: 'Сегодня',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Сутки',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        },  {
          text: 'Вчера',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      ordersChartDetails: {
        show: false,
        label: '',
        user: '',
        ids: [],
      },
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('settings', [
      'actionsStats',
    ]),
    isLoading() {
      return this.loading(LOAD_ACTIONS_STATS) === 'loading';
    },
    ordersStats() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'Завершено заявок',
            labelName: 'orders_finished',
            data: [],
            backgroundColor: '#ff7f50'
          },
          {
            label: 'Открыто претензий',
            labelName: 'claims_added',
            data: [],
            backgroundColor: '#87ceeb'
          },
          {
            label: 'Отменено претензий',
            labelName: 'claims_canceled',
            data: [],
            backgroundColor: '#90ee90'
          },
        ]
      };

      for(let i = 0; i < this.actionsStats.length; i++) {
        let user = this.actionsStats[i];
        data.labels.push(user.username);
        data.datasets[0].data.push(user.orders_finished.amount);
        data.datasets[1].data.push(user.claims_added.amount);
        data.datasets[2].data.push(user.claims_canceled.amount);
      }
      return data;
    },
    otherStats() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'Добавлено в черный список',
            data: [],
            backgroundColor: '#cb7ae9'
          },
        ]
      };

      for(let i = 0; i < this.actionsStats.length; i++) {
        let user = this.actionsStats[i];
        data.labels.push(user.username);
        data.datasets[0].data.push(user.blacklist_added);
      }

      return data;
    },
    messagesStats() {
      let data = {
        labels: [],
        datasets: [
          {
            label: 'Отправлено сообщений',
            data: [],
            backgroundColor: '#daa520'
          },
        ]
      };

      for(let i = 0; i < this.actionsStats.length; i++) {
        let user = this.actionsStats[i];
        data.labels.push(user.username);
        data.datasets[0].data.push(user.messages_sent);
      }

      return data;
    },
    showOrdersChartDetailsTitle() {
      return `Список ID ${this.ordersChartDetails.label} пользователя ${this.ordersChartDetails.user}`;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() -180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapActions('settings', {
      loadStats: LOAD_ACTIONS_STATS,
    }),
    async startLoadStats() {
      await this.loadStats(this.dates);
    },
    showUserOrdersIds({ type, user, label }) {
      const userStats = this.actionsStats.find((stat) => stat.username === user);
      if (userStats) {
        this.ordersChartDetails.label = label;
        this.ordersChartDetails.user = user;
        this.ordersChartDetails.ids = userStats[type].ids;
        this.ordersChartDetails.show = true;
      }
    },
    resetShowOrdersChartDetails() {
      this.ordersChartDetails.show = false;
    }
  }
};
</script>
<style scoped>
.stats__container {
  overflow-y: scroll;
}
.stats__chart {
  margin: 5px auto;
  padding: 5px;
  background-color: #efefef;
}
.filters__container {
  display: flex;
  padding: 5px;
  background-color: #efefef;
  align-content: center;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date__title {
  margin-right: 5px;
  font-size: 12px;
  font-weight: bold;
}

.orders-ids__list {
  height: fit-content;
  overflow-y: scroll;
}

.order__id {
  padding: 2px;
  display: inline-block;
}

</style>
